import { selectSelectedCompanyOrgId, useAppSelector } from '@ibk/shared-config';
import { benefitApi } from '../services/benefitApi';
import { ContractStatus } from '../types';
export function useBenefitContract() {
    const selectedCompanyOrgId = useAppSelector(selectSelectedCompanyOrgId);
    const { data, isLoading, isError, refetch, isFetching } = benefitApi.endpoints.getContractsByOrganization.useQuery({
        organizationId: selectedCompanyOrgId || '',
        status: [
            ContractStatus.CREATED,
            ContractStatus.SYNC_CONTRACT_DATA,
            ContractStatus.PENDING,
            ContractStatus.SYNC_BENEFICIARIES_PARTNER,
            ContractStatus.ACTIVE,
        ],
    });
    const contractData = data?.result[0] || null;
    return {
        contractData,
        hasContract: contractData !== null,
        contractStatus: contractData?.status || null,
        isLoading,
        isRefetching: isFetching && !isLoading,
        isError,
        refetch: async () => {
            await refetch();
        },
    };
}
